<template>
  <b-row>
    <b-col cols="12">
      <b-card>
        <b-overlay
            variant="white"
            :show="showLoading"
            spinner-variant="primary"
            blur="0"
            opacity=".75"
            rounded="sm"
        >
          <div class="p-1">
            <form class="" @submit.prevent="submitForm">
                <div class="row">
                  <div class="form-group col-12 col-md-3">
                    <label for="phone24">Nombre:</label>
                    <b-form-input v-model="proyect.name" autocomplete="off"/>
                    <span v-if="validation_proyect.name" class="text-danger">
                                        {{ validation_proyect.name }}
                                      </span>
                  </div>
                </div>
              <div class="row">
                <button type="submit" class="btn btn-primary col-12 col-md-1 ml-1 mt-2">
                  Guardar
                </button>
              </div>
            </form>
          </div>
        </b-overlay>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import {BCard, BCol, BOverlay, BRow, BFormInput, BFormGroup, BFormCheckbox} from 'bootstrap-vue'
import {mapState} from "vuex"
import {GEI_AUXILIAR2_PROYECTS_LIST} from "@/router/web/constants"
import {createHelpers} from "vuex-map-fields"

import helper from "@/resources/helpers/helpers"

const {mapFields} = createHelpers({
  getterType: 'proyects/getField',
  mutationType: 'proyects/updateField',
})

export default {
  name: "FormView",
  components: {
    BCol,
    BRow,
    BCard,
    BFormInput,
    BOverlay,
  },
  data() {
    return {
      edit: false,
      showLoading: false,
    }
  },
  computed: {
    ...mapState('auxiliaries2Proyects', ['validation_proyect']),
    ...mapFields({
      proyect: 'proyect',
    }),
  },
  created() {

    this.$store.commit('auxiliaries2Proyects/RESET_STATE')
    this.$store.commit('auxiliaries2Proyects/CLEAR_VALIDATION')

    if (this.$route.params.id) {
      this.edit = true
      this.getProyects()
    } else {
      this.edit = false
    }
    this.$root.$refs.auxiliaries2ProyectsForm = this
  },
  methods: {
    getProyects() {
      this.showLoading = true
      this.$store.dispatch('proyects/findProyects', {
        id: this.$route.params.id ?? this.proyect.id
      })
          .then(response => {
            this.showLoading = false
          })
          .catch(error => {
            this.showLoading = false
          })
    },
    cancel() {
      this.$router.push(GEI_AUXILIAR2_PROYECTS_LIST)
    },
    createAuxiliar() {
      this.$store.dispatch('proyects/createProyects', this.proyect)
          .then(response => {
            helper.showToast('Gestor de Proyectos creado correctamente!', 'CheckIcon', 'success')
            this.$router.replace(GEI_AUXILIAR2_PROYECTS_LIST)
          })
          .catch(error => {
            helper.showToast('Error al crear el gestor de proyectos', 'AlertOctagonIcon', 'danger')
            console.log(error)
          })
    },
    updateAuxiliar() {
      this.$store.dispatch('proyects/updateProyects', this.proyect)
          .then(response => {
            helper.showToast('Gestor de Proyectos editado correctamente!', 'CheckIcon', 'success')
            this.$router.replace(GEI_AUXILIAR2_PROYECTS_LIST)
          })
          .catch(error => {
            helper.showToast('Error al editar el gestor de proyectos', 'AlertOctagonIcon', 'danger')
            console.log(error)
          })
    },
    submitForm() {
      if (this.$route.params.id) {
        this.updateAuxiliar()
      } else {
        this.createAuxiliar()
      }
    },
  },
}
</script>